
import React from "react";
import styles from "./Avantages.module.css";
import { AvantagesTypes } from "@/types/displayData/AvantagesTypes";
import { CircleCheck } from "lucide-react";

const AvantagesComponent: React.FC<AvantagesTypes> = ({ title, subtitle, features, imageSrc }) => {
  return (
    <section className={styles.avantagesContainer}>
      <div className={styles.imageContainer}>
        <img src={imageSrc} alt="Illustration" className={styles.image} />
      </div>

      <div className={styles.textContainer}>
        <h2 className={styles.title}>{title}</h2>
        <h3 className={styles.subtitle}>{subtitle}</h3>

        <div className={styles.featureContainer}>
          {features.map((feature, index) => (
            <div key={index} className={styles.featureBlock}>
              <div className={styles.iconContainer}>
                <CircleCheck className={styles.featureIcon} />
              </div>
              <div>
                <h4 className={styles.featureTitle}>{feature.title}</h4>
                <p className={styles.featureDescription}>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AvantagesComponent;
